export interface Plan {
  id: string;
  name: string;
  price: number;
}

export interface User {
  id: string;
  name: string;
  email: string;
  documentNumber: string;
  phone: string;
  whatsappNumber: string;
  isWhatsappConfirmed: boolean;
  isCompany: boolean;
  image: string;
  imageUrl?: string;
  companyName: string;
  role: string;
  invoiceEmail: string;
  enabled: boolean;
  isAdmin: boolean;
  isFirstLogin: boolean;
  su: boolean;
  plan?: Plan;
  inboundEmailAlias?: string;
  // Aviso "geração automática agora é dos planos pagos" já visto (out/2026)
  monitoringDowngradeNoticeSeenAt?: string | null;
  // Conta multiusuário (set/2026): papel dentro da conta. 'owner' = titular
  // (pode gerir plano/equipe); 'member' = login convidado (leitura+escrita dos
  // dados, sem billing/equipe). ownerUserId aponta para o mestre (null no dono).
  accountRole?: string;
  ownerUserId?: string | null;
}

// Helper de UI: o usuário logado é o titular da conta? (default owner p/ contas
// antigas sem o campo). O gate de verdade está no backend (isAccountOwner).
export const isAccountOwner = (
  user?: Pick<User, 'accountRole'> | null
): boolean => (user?.accountRole ?? 'owner') === 'owner';

export interface SignInProps {
  email: string;
  password: string;
}

export interface SpoofedInUserProps {
  email: string;
  password: string;
  clientId: string;
}

// export interface SpoofedOutUserProps {}

export interface SocialSignInProps {
  token: string;
  provider: string;
}

/**
 * Plano e PF/PJ da tela de cadastro (out/2026) — comum ao cadastro por e-mail
 * e ao social. Espelha `SignupProfileDto` do backend.
 */
export interface SignupProfileProps {
  planName?: string;
  declaredGroupACount?: number;
  declaredGroupBCount?: number;
  paymentMethod?: 'pix' | 'boleto' | null;
  isCompany?: boolean;
  documentNumber?: string;
  companyName?: string;
  role?: string;
  invoiceEmail?: string;
  phone?: string;
  whatsappNumber?: string;
  billingAddress?: string | null;
  billingZipCode?: string | null;
  billingCity?: string | null;
  billingState?: string | null;
}

export interface SignUpProps extends SignupProfileProps {
  name: string;
  email: string;
  password: string;
  token: string;
  documentNumber: string;
  phone: string;
  whatsappNumber: string;
  isCompany: boolean;
  companyName: string;
  role: string;
  invoiceEmail: string;
  // LGPD — aceites obrigatórios no cadastro
  acceptedTerms: boolean;
  acceptedPrivacy: boolean;
  acceptedAdhesion: boolean;
}

export interface SocialSignUpProps extends SignupProfileProps {
  token: string;
  provider: string;
  // LGPD — aceites obrigatórios no cadastro
  acceptedTerms: boolean;
  acceptedPrivacy: boolean;
  acceptedAdhesion: boolean;
}

export interface ConfirmEmailProps {
  token: string;
}

export interface ConfirmWhatsappProps {
  token: string;
}

export interface ForgotPasswordProps {
  email: string;
}

export interface ResetPasswordProps {
  token: string;
  password: string;
}

export interface UploadUserImageProps {
  file: Blob;
}

export interface UpdateUserProps {
  name: string;
  email: string;
  documentNumber: string;
  phone: string;
  whatsappNumber: string;
  isWhatsappConfirmed: boolean;
  isToVerifyWhatsapp: boolean;
  isCompany: boolean;
  companyName: string;
  role: string;
  invoiceEmail: string;
  changePassword: boolean;
  password: string;
  newPassword: string;
  isFirstLogin: boolean;
  isFinishUser: boolean;
}
